// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./static/css/mobileDetail.css
// module id = 865
// module chunks = 41